module.exports = __webpack_public_path__ + "static/media/pakistan.5911db5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pakistan.svg
// module id = 370
// module chunks = 1